import s from './TextBlock.module.css';
import { TextBlockEntity } from '@/types/model';
import { motion } from 'framer-motion';

const TextBlock = ({ description, title }: TextBlockEntity) => {
  return (
    <motion.div
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.3 } }}
      className={s.container}>
      <h2>{title}</h2>
      <p>{description}</p>
    </motion.div>
  );
};

export default TextBlock;
